import { activeCurrencies } from 'utils';

export const recordedCurrency = (code) => code?.toLowerCase() === 'zig' ? 'ZWL' : code || 'UNKNOWN';

export const formatRecordedMoney = (amount, currency, metadata = {}) => {
    const code = recordedCurrency(currency);
    const places = metadata.decimal_places ?? activeCurrencies[code]?.decimal_places ?? 2;
    if (amount === null || amount === undefined || !Number.isFinite(Number(amount))) return `${code} —`;
    // Preserve decimal strings from the ledger rather than losing cents in a Number conversion.
    const raw = String(amount);
    if (!/^-?\d+(\.\d+)?$/.test(raw)) return `${code} ${Number(amount).toLocaleString(undefined, { minimumFractionDigits: places, maximumFractionDigits: places })}`;
    const negative = raw.startsWith('-');
    const [whole, fraction = ''] = raw.replace(/^-/, '').split('.');
    let digits = (whole + fraction.padEnd(places, '0').slice(0, places)).split('');
    if (Number(fraction[places] || '0') >= 5) {
        let index = digits.length - 1;
        while (index >= 0 && digits[index] === '9') { digits[index] = '0'; index--; }
        if (index >= 0) digits[index] = String(Number(digits[index]) + 1);
        else digits.unshift('1');
    }
    const rounded = digits.join('').padStart(places + 1, '0');
    const integer = (places ? rounded.slice(0, -places) : rounded).replace(/^0+(?=\d)/, '');
    const parts = new Intl.NumberFormat().formatToParts(1000.1);
    const group = parts.find((part) => part.type === 'group')?.value || ',';
    const decimal = parts.find((part) => part.type === 'decimal')?.value || '.';
    const sign = negative && /[1-9]/.test(rounded) ? '-' : '';
    const formatted = integer.replace(/\B(?=(\d{3})+(?!\d))/g, group);
    return `${code} ${sign}${formatted}${places ? decimal + rounded.slice(-places) : ''}`;
};
